import React from 'react';

import StandardModal from '../../Shared/UI/StandardModal/components/StandardModal';
import PageTitle from '../../Shared/UI/PageTitle/components/PageTitle';
import UpdateJobDescriptionFromExternalWebsiteForm from './UpdateJobDescriptionFromExternalWebsiteForm';

import { useJobDescriptionsFromExternalWebsitesState, useJobDescriptionsFromExternalWebsitesActions } from './JobDescriptionsFromExternalWebsitesContext';

const UpdateJobDescriptionFromExternalWebsiteModal = () => {
  const jobDescriptionsFromExternalWebsitesState = useJobDescriptionsFromExternalWebsitesState();
  const { closeUpdateJobDescriptionFromExternalWebsiteModal } = useJobDescriptionsFromExternalWebsitesActions();

  return (
    <StandardModal
      isOpen={jobDescriptionsFromExternalWebsitesState?.updateJobDescriptionFromExternalWebsiteModalIsOpen}
      contentLabel={'Update Job Description from External Website'}
      onRequestClose={() => {
        closeUpdateJobDescriptionFromExternalWebsiteModal();
      }}
    >
      <UpdateJobDescriptionFromExternalWebsiteForm />
    </StandardModal>
  );
};

export default UpdateJobDescriptionFromExternalWebsiteModal;